export const goBack = (history) => {
  const lastMainPage = localStorage.getItem('lastMainPage');
  lastMainPage ? history.push(`/${lastMainPage}`) : history.push('/');
};
